import App from './App.svelte';



window.CreateInlineSearch = function (target, courseTypes, apiUrl,title,subTitle,noofitems, showFilter,style, allCategories, allTags, adminPickedCategory, adminPickedTags, postType ) {
	
	
	var app = new App({
		target: document.getElementById(target),
		props: {courseTypes:courseTypes, apiUrl: apiUrl,title:title,subTitle:subTitle, showFilter:showFilter,noofitems:noofitems,style:style, allCategories:allCategories,allTags:allTags,adminPickedCategory:adminPickedCategory,adminPickedTags:adminPickedTags, postType:postType}
	});
}